import { Loader2Icon } from 'lucide-react'

import { cn } from '@/lib/utils'

// 使い方のルール: docs/develop/client_ui/components/feedback.md

function Spinner({ className, 'aria-hidden': ariaHidden, ...props }: React.ComponentProps<'svg'>) {
  // 読み込み中の告知（role="status"）を持つ親（例: DataTableShell のオーバーレイ）に埋め込むときは、
  // aria-hidden を渡して装飾扱いにする。role="status" が親子で二重になり、読み上げが重複するのを防ぐため
  // （2026/08 レビューFBで発覚。単独使用時は従来どおり自身が status を持つ）
  return (
    <Loader2Icon
      data-slot="spinner"
      role={ariaHidden === true ? undefined : 'status'}
      aria-hidden={ariaHidden}
      aria-label={ariaHidden === true ? undefined : 'Loading'}
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  )
}

export { Spinner }
